import React, { useContext, useState, useRef } from 'react';
import styles from './ModalGrupyTechnologii.module.css';
import { TechnologyContext } from 'context/TechnologyContext';
import { getNameOfElementTyp } from 'actions/getNameOfElementTyp';
import { _typ_elementu } from 'utils/initialvalue';
import { getNameStatus } from 'actions/getNameStatus';
import { AppContext } from 'context/AppContext';
import { useGrupyWykonanFirst } from 'hooks/useGrupyWykonanFirst';
import { updateWydzielWykonanieZgrupyGant } from 'actions/updateWydzielWykonanieZgrupyGant';
import { useGant } from '../useGant';
import { updatePrzeniesWykonanieDoInnejGrupyGant } from 'actions/updatePrzeniesWykonanieDoInnejGrupyGant';
import { dragDropProcesGrupaToProcesorGantModal } from 'actions/dragDropProcesGrupaToProcesorGantModal';

const ModalGrupyTechnologii = ({ 
  modalGrupyOpen, 
  setModalGrupyOpen, contextMenu, selectedGrup
}) => {
  const { grupaWykonan, wykonania, setWykonania, fechparametryTechnologii } = useContext(TechnologyContext);
  const { _status_wykonania,procesory } = useContext(AppContext);
  const [localgrupy, setLocalGrupy] = useState(grupaWykonan);
  const [localwykonania, setLocalWykonania] = useState(wykonania);
  const [selectedWykonanie, setSelectedWykonanie] = useState(null);

  const [updateGrupaWykonan] = useGrupyWykonanFirst()
    const {refreshGant, refreshGantAll, generujPolaczenia} = useGant();
  


  
  // Stan dla przeciągania wykonania
  const [draggedWykonanie, setDraggedWykonanie] = useState(null);

  // Stany do obsługi przeciągania całego okna modala
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef({ startX: 0, startY: 0 });

  if (!modalGrupyOpen) return null;

  const onClose = () => {
    setModalGrupyOpen(false);
    setSelectedWykonanie(null)
  };

  const canSplitWykonanie = () => {
    if (!selectedWykonanie) {
      return false;
    }
    if (wykonania.filter(gw => gw.grupa_id == selectedWykonanie.grupa_id).length > 1) {
      return true;
    } else {
      return false;
    }
  };

  const onConfirm = () => {
    setModalGrupyOpen(false);
  };

  const handleTechChange = (globalId, field, value) => {
    setLocalWykonania(prev => 
      prev.map(wyk => 
        wyk.global_id === globalId ? { ...wyk, [field]: value } : wyk
      )
    );
  };

  const handleConfirmClick = () => {
    if (onConfirm) {
      onConfirm({ localgrupy, localwykonania });
    }
    onClose();
  };

  const handleWydziel = () => {
    updateWydzielWykonanieZgrupyGant(selectedWykonanie.global_id, fechparametryTechnologii, selectedWykonanie.zamowienie_id,refreshGantAll);
    setSelectedWykonanie(null);
  };

  // --- OBSŁUGA PRECIĄGANIA WYKONAŃ MIĘDZY GRUPAMI ---
  const handleDragStart = (e, wyk) => {
    e.stopPropagation(); // Zatrzymujemy propagację, aby nie wywoływać innych zdarzeń
    setDraggedWykonanie(wyk);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Wymagane, aby umożliwić upuszczenie elementu (drop)
  };

  const handleDrop = (e, targetGrupa) => {
    e.preventDefault();
    if (!draggedWykonanie) return;

    // Jeśli upuszczamy w tej samej grupie, nic nie robimy
    if (draggedWykonanie.grupa_id === targetGrupa.id) {
      setDraggedWykonanie(null);
      return;
    }

    // Sprawdzamy, czy przeciągane wykonanie było ostatnie w swojej dotychczasowej grupie
    const itemsInOriginalGroup = wykonania.filter(w => w.grupa_id === draggedWykonanie.grupa_id);
    // const isLastInGroup = itemsInOriginalGroup.length === 1;
     let isLastInGroup
    if(itemsInOriginalGroup.length>1){
        isLastInGroup = false
        }else isLastInGroup = true

    // Wywołanie Twojej funkcji przekazującej parametry:
    // 1. global_id_wykonania, 2. grupa_id nowej grupy, 3. czy było ostatnie w starej grupie
    updatePrzeniesWykonanieDoInnejGrupyGant(
      draggedWykonanie.global_id, 
      targetGrupa.id, 
    
      fechparametryTechnologii,
        isLastInGroup,
      draggedWykonanie.zamowienie_id,generujPolaczenia
    );

    // Czyszczenie stanu przeciągania
    setDraggedWykonanie(null);
  };
  // -------------------------------------------------

  // Obsługa rozpoczęcia przeciągania okna modala
// Obsługa rozpoczęcia przeciągania okna modala
  const handleMouseDown = (e) => {
    // Ignorujemy kliknięcia w przyciski oraz w obszar zmiany rozmiaru CSS
    if (e.target.closest('button') || e.target.closest('select') || e.target.closest('input')) {
      return;
    }
    
    setIsDragging(true);
    dragRef.current = {
      startX: e.clientX - position.x,
      startY: e.clientY - position.y
    };
  };

  // Obsługa ruchu myszy dla okna modala
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragRef.current.startX,
      y: e.clientY - dragRef.current.startY
    });
  };

  // Zakończenie przeciągania okna modala
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div 
      className={styles.overlay} 
      onMouseMove={handleMouseMove} 
      onMouseUp={handleMouseUp}
    >
      <div 
        className={styles.modal}
        style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
      >
        
        {/* Nagłówek modala - uchwyt do przeciągania */}
        <div 
          onMouseDown={handleMouseDown}
          onDoubleClick={() => {
            console.table(grupaWykonan);
            console.table(wykonania);
          }} 
          className={styles.header}
        >
          <h2 className={styles.title}>
            {selectedGrup?.nazwa} <span className={styles.titleMini}> {getNameOfElementTyp(selectedGrup?.typ_elementu, _typ_elementu)} </span> {selectedGrup?.nr}_{selectedGrup?.rok.substring(2,4)} {selectedGrup?.firma_nazwa} {selectedGrup?.tytul}
          </h2>
          <button onClick={onClose} className={styles.closeButton}>
            &times;
          </button>
        </div>

        {/* Zawartość modala */}
        <div className={styles.content}>
          {grupaWykonan?.filter(x => x.proces_id == selectedGrup?.proces_id).map((grupa) => {
            return (
              <div 
                key={grupa.global_id} 
                className={styles.groupCard}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, grupa)} // <-- Tutaj odbieramy upuszczenie na danej grupie
              >
                
                <div className={styles.groupHeader}>
                  <span className={styles.groupTitle}>


                          <select
        className={styles.inputSelect}
        value={grupa.procesor_id}
        // disabled={  !wolno_procesor(rowProces.nazwa_id)}
        onChange={(event) => {
            // updateGrupaWykonan({ ...grupa, procesor_id: event.target.value });
            dragDropProcesGrupaToProcesorGantModal(grupa.global_id,event.target.value,fechparametryTechnologii,selectedGrup.zamowienie_id,selectedGrup.technologia_id,refreshGantAll)

    
        }}
>
                {procesory
        // .filter(x => x.grupa == rowProces.nazwa_id && x.virtual != 1)
        .filter(x => {
   
    const isSameGroup = x.grupa == selectedGrup.proces_nazwa_id;
    // const virtualCondition = daneTech.stan == 1 ? x.virtual == 1 : x.virtual != 1;
    
    // return isSameGroup && virtualCondition;
    return isSameGroup;
  })
        .map((option) => (
          <option key={option.id} value={option.id}>
            {option.nazwa}
          </option>
        ))}
      </select>

                    {/* Grupa ID: {grupa.id} — {grupa.nazwa} (Indeks: {grupa.indeks}) */}
                 ID: {grupa.id} 
                  </span>
                  <div className={styles.groupInfo}>
                    <span>Nakład : <b>{grupa.naklad}</b></span>
                    <span>Narząd: <b>{grupa.narzad}</b></span>
                    <span>Początek: <b>{grupa.poczatek}</b></span>
                    <span>Czas: <b>{grupa.czas}</b></span>
                    <span>Koniec: <b>{grupa.koniec}</b></span>
                    <span>Status: <b>{grupa.status}</b></span>
                  </div>
                </div>

                {wykonania.length === 0 ? (
                  <p className={styles.noTech}>Brak przypisanych technologii wykonania.</p>
                ) : (
                  <div className={styles.tableContainer}>
                    <table className={styles.table}>
                      <thead>
                        <tr>
                          <th>Nr</th>
                          <th>Nakład</th>
                          <th>Czas (min)</th>
                          <th>Narząd</th>
                          <th>Przeloty</th>
                          <th>Prędkość</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wykonania.filter(wyk => wyk.grupa_id == grupa.id).map((wyk) => (
                          <tr
                            key={wyk.global_id}
                            draggable={true} // <-- Umożliwiamy przeciąganie wiersza
                            onDragStart={(e) => handleDragStart(e, wyk)} // <-- Start przeciągania wykonania
                            onClick={() => {
                              setSelectedWykonanie(wyk);
                              setWykonania(
                                wykonania
                                  .map((t) => ({ ...t, select: false }))
                                  .map((t) => t.global_id === wyk.global_id ? { ...t, select: true } : t)
                              );
                            }}
                            className={wyk.select ? styles.rowWykonanieSelect : styles.rowWykonanie}
                          >
                            <td>{wyk.nr_arkusza}</td>
                            <td>
                              <input
                                type="number"
                                value={wyk.naklad}
                                onChange={(e) => handleTechChange(wyk.global_id, 'naklad', Number(e.target.value))}
                                className={styles.input}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={wyk.czas}
                                onChange={(e) => handleTechChange(wyk.global_id, 'czas', Number(e.target.value))}
                                className={styles.input}
                              />
                            </td>
                            <td>{wyk.narzad}</td>
                            <td>{wyk.przeloty}</td>
                            <td>{wyk.predkosc}</td>
                            <td>{getNameStatus(wyk.status, _status_wykonania)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

              </div>
            );
          })}
        </div>

        {/* Stopka */}
        <div className={styles.footer}>
          {canSplitWykonanie() && (
            <button type="button" onClick={handleWydziel} className={styles.buttonConfirm}>
              Wydziel zaznaczone wykonanie do nowej grupy
            </button>
          )}
          <button type="button" onClick={onClose} className={styles.buttonCancel}>
            Anuluj
          </button>
        </div>

      </div>
    </div>
  );
};

export default ModalGrupyTechnologii;